<template>
  <div
    class="sky__category-header relative pt-3 lg:pb-10 overflow-hidden"
  >
    <div
      class="category-background absolute left-0 right-0 top-0 overflow-visible z-0"
      :style="{
        transform: `translateY(-${($store.state.screen.scroll * 0.4)}px)`,
        backgroundImage: category.properties && category.properties.cover_picture ? `url(${category.properties.cover_picture}?resize=true&width=1800&format=webp)` : null,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        height: '600px'
      }"
    />
    <div class="relative z-10 container mx-auto">
      <div class="breadcrumb-wrapper hidden md:block" style="position: absolute; top: 0px; left:10px;">
        <breadcrumb
          :value="breadcrumb"
          :dark="category.properties.le_fond_est_sombre"
        />
      </div>
      <div
        class="sky__category-header-content text-center"
        :class="{
          'text-white': category.properties.le_fond_est_sombre
        }"
      >
        <h1 class="font-funny text-5xl">
          {{ category.label }}
        </h1>
        <p v-if="category.properties.description" class="text-sm px-2 hidden lg:block">
          {{ category.properties.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../general/Breadcrumb'
export default {
  components: {
    Breadcrumb
  },
  props: {
    category: {
      required: true,
      type: Object
    }
  },
  computed: {
    breadcrumb () {
      const breadcrumb = this.category.hierarchy.map((hierarchy) => {
        return {
          text: hierarchy.label,
          to: this.$helpers.makeUri(hierarchy.path, 'category')
        }
      })

      return breadcrumb
    }
  }
}
</script>

<style lang="scss" scoped>
.sky__category-header-content {
  max-width: 563px;
  @apply mx-auto py-14;
}
.sky__category-description-title {
  @apply text-3xl font-funny text-center px-5;
  @screen md {
    @apply text-5xl;
  }
}
</style>
